import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  outerCircle: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  innerDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: palette.primary.main,
    position: 'absolute'
  }
}))

/**
 * Focus Icon Component
 * A circular icon with a centered dot, representing focus/learning journey
 * Used in context bars, breadcrumbs, and learning journey pages
 */
export const FocusIcon = ({ className, ...props }) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.root} ${className || ''}`} {...props}>
      <Box className={classes.outerCircle}>
        <Box className={classes.innerDot} />
      </Box>
    </Box>
  )
}

FocusIcon.propTypes = {
  className: PropTypes.string
}
